import { render, staticRenderFns } from "./CompanyLocation.vue?vue&type=template&id=4519b1da"
import script from "./CompanyLocation.vue?vue&type=script&lang=js"
export * from "./CompanyLocation.vue?vue&type=script&lang=js"
import style0 from "./CompanyLocation.vue?vue&type=style&index=0&id=4519b1da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports